module.exports = __webpack_public_path__ + "static/media/download.899d1788.svg";